"use client";

import type { ReactNode } from "react";

/** Native browser scrolling keeps input responsive on long marketing pages. */
export function LenisProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
